import { render } from "./OpportunityShow.vue?vue&type=template&id=3b6333f2&scoped=true"
import script from "./OpportunityShow.vue?vue&type=script&lang=js"
export * from "./OpportunityShow.vue?vue&type=script&lang=js"

import "./OpportunityShow.vue?vue&type=style&index=0&id=3b6333f2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6333f2"]])

export default __exports__